import Vue from 'vue'
import Router from 'vue-router'
import WebPrevious from '@/pages/WebPrevious'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'WebPrevious',
      component: WebPrevious
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js